// Universal password rules
//      1. Minimum eight characters
//      2. Minimum number
//      3. Minimum one upper case and one lower case
//      4. !@#$%^&*()_-=+[]{};:'"<>,./|?`~ are all legal
//      5. Whitespace is not allowed (because passwords are trimmed to avoid typing mistakes)
export const pwdRegex: RegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[-A-Za-z\d!@#$%^&*()_=+[\]{};:'"<>,./?`|~]{8,}$/;
// Check to make sure password is well formed
export function genPwdRulesValidator(pwdInput) {
    return () => {
        if (pwdInput.value.match(pwdRegex) == null) {
            pwdInput.setCustomValidity('Your password must be at least 8 characters long and contain ' +
                                       'at least one number, at least one upper-case, and one lower-case letter. No whitespace. ' +
                                       'It may also contain any of these characters: !@#$%^&*()_-=+[]{};:\'"<>,./|?`~');
        }
        else {
            pwdInput.setCustomValidity('');
        }
    };
}

// Check to make sure password is confirmed
export function genPwdMatchValidator(pwdInput, confirmInput) {
    return () => {
        if (pwdInput.value === confirmInput.value) {
            confirmInput.setCustomValidity('');
        }
        else {
            confirmInput.setCustomValidity('Passwords must match');
        }
    };
}
